module.exports = __webpack_public_path__ + "static/media/responsibility-health.4c51f448.jpg";